import React from 'react';
import { useEmployeeOrderProductionTypeInputQuery } from '../../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../../dum';
import { IEmployee } from '../../employee-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function OrderProductionTypeInput() {
    const inputName: keyof IEmployee = 'order_production_type_id';

    const { data } = useEmployeeOrderProductionTypeInputQuery();

    const orderProductionTypes = data?.getOrderProductionTypes || [];

    return (
        <RhSingleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            name={inputName}
            label={shortLabel(FIELD_LABELS.order_production_type_id)}
            options={orderProductionTypes}
        />
    );
}
